import sharedPackageInfo from '../../node_modules/@deighton/shared-ui/package.json';
import packageInfo from '../../package.json';
import { Environment } from './types/environment.type';

/**
 * Development environment configuration.
 * Used when running `ng serve` with the default `development` configuration.
 *
 * NOTE: Do NOT place secrets or API tokens here — use environment.local.ts instead.
 * See environment.local.ts.example for setup instructions.
 */
export const environment: Environment = {
  development: true,
  shellAppVersion: packageInfo.version,
  sharedLibraryVersion: sharedPackageInfo.version,
  mapboxAccessToken: 'pk.eyJ1IjoibXN1Yml0IiwiYSI6ImNtMjNzNDhnczA5Y2IyanBzeW1vamdxc3cifQ.kVmt3A_muSLagcoeuyNIiQ',
  platformApiBaseUrl: 'https://cnc.api.dtims.ai',
  okta: {
    issuer: 'https://deighton-devops.okta.com/oauth2/default',
    clientId: '0oa11979fx1CmnsxG698',
    redirectUri: '/login/callback',
    scopes: ['openid', 'profile', 'email', 'groups', 'offline_access'],
    oktaStorageKey: 'okta-token-storage-shell'
  }
};
